import styled from "styled-components";
import { fluid } from "@/styles/utils/fluid";

export const AppLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const PageLayoutWrapper = styled.div`
  max-width: 1728px;
  min-width: 360px;
  position: relative;
  margin: ${({ theme }) => `
    0
    ${fluid({
      minSize: theme.spacing.vertical.xs,
      maxSize: theme.spacing.vertical.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
  `};
`;

export const Grid = styled.article`
  display: grid;
  gap: 0;
  min-height: 0;
  min-width: 0; /* NEW; needed for Firefox */
  &:last-of-type {
    border-bottom: none;
  }
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-template-columns: 1fr;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-template-columns: 1fr;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-template-columns: [outer-start] 1fr [center-start] 8fr [center-end] 1fr [outer-end];
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-template-rows: min-content 1fr;
    grid-template-columns: [outer-start] 1fr [center-start] 6fr [center-end] 1fr [outer-end];
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-template-rows: auto;
    grid-template-columns: [outer-start] 1fr [center-start] 3fr [center-end] 1fr [outer-end];
  }
`;

export const GridItem = styled.div`
  p:first-of-type {
    padding-top: 0;
  }
  p:last-child {
    padding-bottom: 0;
  }
  grid-template-rows: min-content 1fr;
  padding-bottom: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.section.xs,
      maxSize: theme.spacing.section.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    grid-column: outer-start / outer-end;
    /* grid-column: center-start / center-end; */
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    grid-column: center-start / center-end;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    grid-column: center-start / center-end;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    grid-column: center-start / center-end;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    grid-column: center-start / center-end;
  }
`;

export const Divider = styled.hr`
  width: 100px;
  height: 4px;
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  border-bottom: 1px solid ${({ theme }) => theme.colors.phillipineSilver};
  margin: ${({ theme }) => `
    ${fluid({
      minSize: theme.spacing.element.xs,
      maxSize: theme.spacing.element.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })}
    auto
  `};
`;

export const SectionDivider = styled.hr`
  position: relative;
  max-width: 1728px;
  min-width: 360px;
  padding: 0;
  margin: 0;
  height: 8px;
  border-top: 2px solid ${({ theme }) => theme.colors.onyx};
  border-bottom: 0;
  border-left: 0;
  border-right: 0;
  background-color: transparent;
  /* Custom Dashed Line */
  &::before {
    content: "";
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.onyx} 50%,
      rgba(255, 255, 255, 0) 0%
    );
    background-position: bottom;
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
`;

export const Cards = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: 32px;
  border: 4px solid ${({ theme }) => theme.colors.onyx};
  &::before {
    content: "";
    background-color: ${({ theme }) => theme.colors.white};
    outline: 4px solid ${({ theme }) => theme.colors.white};
    position: absolute;
    border-radius: 24px;
    top: 4px;
    left: 4px;
    right: 4px;
    bottom: 4px;
    z-index: -1;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='24' ry='24' stroke='%23333' stroke-width='2' stroke-dasharray='8%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  }
  padding: ${({ theme }) =>
    fluid({
      minSize: theme.spacing.card.xs,
      maxSize: theme.spacing.card.xl,
      minVW: theme.breakpointValues.xs,
      maxVW: theme.breakpointValues.xl,
      baseFontMin: theme.baseFont.xs,
      baseFontMax: theme.baseFont.xl,
    })};
  h3,
  legend {
    position: absolute;
    top: -16px;
    left: 50%;
    z-index: 10;
    transform: translateX(-50%) rotate(-4deg);
  }
  fieldset {
    border: 0;
    padding: 0;
    width: 100%;
  }
  small {
    width: 100%;
    text-align: center;
  }
`;
